import React from "react";
const TermsMain = () => {
  return (
    <div className="text-center terms-container">
      <h1 className="">Terms and Conditions</h1>
      <div className="terms-content">
        <p>
          Welcome to Sunrising Cinevision!<br />
          These terms and conditions outline the rules and regulations for the use of our website. By accessing this website, you accept these terms in full. If you disagree with any part of these terms, please do not use our website.
        </p>
        <p>
          The following terminology applies: "Client", "You" and "Your" refers to you, the user of this website; "The Company", "Ourselves", "We", "Our" refers to Sunrising Cinevision. Content published on this website is the property of Sunrising Cinevision and/or its licensors.
        </p>
        <p>
          We reserve the right to modify these terms at any time without prior notice. Your continued use of the site means you accept any changes.
        </p>
      </div>
    </div>
  );
};

export default TermsMain;
